import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ENGAGEMENT_AUTH_ERROR_MESSAGE } from "./engagementAuthNotice";

export default function EngagementAuthDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Login Required</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">
          {ENGAGEMENT_AUTH_ERROR_MESSAGE} In order to engage, you need to be logged in as an artist, host, or buyer. Register at{" "}
          <Link
            component={RouterLink}
            to="/register"
            sx={{ color: "primary.main", textDecoration: "underline", fontWeight: 600 }}
            onClick={onClose}
          >
            /register
          </Link>
          .
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
}
